<template lang="pug">
.resource-view-wrapper(:class="'context-' + context")
  include BenefitsPack.pug
</template>

<script>
import slug from "slug"
import Api from "@/components/services/Api";
import _ from 'underscore'
import PrivateRouterLink from '@/directives/PrivateRouterLink'
import BenefitsPackItem from "./BenefitsPackItem"
import { mapState } from 'vuex';

export default {
  name: 'BenefitsPack',
  props: [],
  components: {
    PrivateRouterLink,
    BenefitsPackItem,
  },
  computed: mapState([
    "context", "token",
  ]),
  data() {
    return {
      perms: [],
      groups: [
        "Registro",
        "Perfil",
        "Marketing",
        "Recursos",
        "Descuentos",
      ],
    }
  },
  async created() {
    if (!this.token) {
      this.$router.push({
        name: "Root",
      })
      return
    }

    const meResponse = await Api.me(this.token)
    const meData = meResponse.data
    const plan = meData.plan

    const permissionsResponse = await Api.getPermissions()
    const data = permissionsResponse.data

    const perms = data[plan]
    this.perms = perms
  },
  methods: {
    inGroup(item, group) {
      if (!item.visible) return false
      const groupSlug = slug(group).toUpperCase()
      const splittedPerm = _.first(item.name.split("_"))
      return (groupSlug == splittedPerm)
    }
  },
  filters: {
    groupname: function(value) {
      const lowername = value.toLowerCase()
      switch (lowername) {
        case "registro":
          return "Credenciales Federativas"
        case "recursos":
          return "Recursos Profesionales"
        case "descuentos":
          return "Descuentos del Sector"
        case "marketing":
          return "Kit de Marketing"
        case "perfil":
          return "Perfil Profesional"
      }

      return value
    }
  }
}
</script>

<style lang="scss">
@import './../../variables';
@import './../../variables_colreps';

.resource-view-wrapper {
  @import '../dashboard/Dashboard';
  @import '../dashboard/DashboardIndex';
  @import 'Benefits';
  @import 'BenefitsPack';
}

</style>



// WEBPACK FOOTER //
// src/components/benefits/BenefitsPack.vue